import { useSelector } from "react-redux";
import styled from "styled-components";
import {
	getProctoringPassed,
	getProctoringPassedAt,
} from "selectors/userInfo";

const MONTHS = [
	"января",
	"февраля",
	"марта",
	"апреля",
	"мая",
	"июня",
	"июля",
	"августа",
	"сентября",
	"октября",
	"ноября",
	"декабря",
];

// API отдаёт "DD.MM.YYYY" либо "YYYY-MM-DD[ HH:MM:SS]" — парсим явно,
// т.к. new Date("05.10.2026") трактует строку как MM.DD.YYYY
const formatPassedDate = (raw: string): string | null => {
	const ru = raw.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})/);
	const iso = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
	const parts = ru
		? { day: +ru[1], month: +ru[2], year: +ru[3] }
		: iso
			? { day: +iso[3], month: +iso[2], year: +iso[1] }
			: null;
	if (!parts || parts.month < 1 || parts.month > 12 || parts.day < 1 || parts.day > 31) {
		return null;
	}
	return `${parts.day} ${MONTHS[parts.month - 1]} ${parts.year}`;
};

interface ProctoringPassedBannerProps {
	className?: string;
}

export const ProctoringPassedBanner = ({
	className,
}: ProctoringPassedBannerProps) => {
	const proctoringPassed = useSelector(getProctoringPassed);
	const passedAt = useSelector(getProctoringPassedAt);

	if (!proctoringPassed) {
		return null;
	}

	const passedDate = passedAt ? formatPassedDate(passedAt) : null;

	return (
		<Banner className={className}>
			<IconCircle>
				<svg
					width="28"
					height="28"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M5 12.5L10 17.5L19 7.5"
						stroke="#fff"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			</IconCircle>
			<TextBlock>
				<Title>Экзамен с прокторингом успешно сдан!</Title>
				<Subtitle>
					{passedDate ? `Сдан ${passedDate}. ` : ""}
					Результат зафиксирован — вы готовы к экзамену в ГАИ
				</Subtitle>
			</TextBlock>
		</Banner>
	);
};

export default ProctoringPassedBanner;

const Banner = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	background: rgba(74, 195, 101, 0.1);
	border: 1px solid rgba(74, 195, 101, 0.4);
	border-radius: 16px;
	padding: 18px 24px;

	@media screen and (max-width: 910px) {
		padding: 14px 16px;
		gap: 12px;
		border-radius: 12px;
	}
`;

const IconCircle = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 48px;
	height: 48px;
	border-radius: 50%;
	background: #4ac365;

	@media screen and (max-width: 910px) {
		width: 40px;
		height: 40px;
	}
`;

const TextBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

const Title = styled.p`
	margin: 0;
	font-size: 1.125rem;
	font-weight: 600;
	line-height: 1.3;
	color: #1e7a35;

	@media screen and (max-width: 910px) {
		font-size: 1rem;
	}
`;

const Subtitle = styled.p`
	margin: 0;
	font-size: 0.875rem;
	line-height: 1.4;
	color: #62686b;
`;
